import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthLayout } from "../Components/AuthLayout";
import UnderMaintanance from "../Components/UnderMaintanance";
import "react-toastify/dist/ReactToastify.css";
import "../Components/Common/Toast/toast.component.css";
import { useDispatch, useSelector } from "react-redux";
import { Suspense, lazy, useEffect, useLayoutEffect, useState } from "react";
import { Fallback } from "../Components/Common/Fallback";
import ConsumersDetailsPage from "../Components/Bank/CampaignManagement/ConsumersWorkFlow/ConsumersDetailsPage";
import CampaignPrivateRoutes from "./CampaignPrivateRoutes";
import ResellerRestrictedRoutes from "./ResellerRestrictedRoutes";
import SetupInprogress from "../Components/Auth/setupInprogress/SetupInprogress";
import NoFHSReseller from "../Components/NoFHSReseller/NoFHSReseller";
import CohortManagement from "../Components/Bank/CohortManagement/CohortManagement";
import { fetchHealthCheckApi } from "../Redux/maintenanceSlice";
import { PRIVILEGES } from "../utils/privileges";
import ProtectedRouteWithSubscription from "./ProtectedRouteWithSubscription";
import CohortPage from "../Components/Bank/Cohort/CohortPage";
import { useSubscription } from "../hooks/useSubscription";

export const NavigatingRoutes = () => {
  const dispatch = useDispatch();
  const { hasSubscription } = useSubscription();
  const authReducer = useSelector((state) => state.authReducer);
  const orgReducer = useSelector((state) => state.orgReducer);
  const navigate = useNavigate();
  const location = useLocation();

  const { data: maintenanceData, isLoading } = useSelector(
    (state) => state?.maintenanceReducer?.maintenanceData,
  );

  useLayoutEffect(() => {
    dispatch(fetchHealthCheckApi());
  }, [dispatch]);

  const ProtectedRoute = lazy(
    () => import(/* webpackChunkName: "ProtectedRoute" */ "./ProtectedRoute"),
  );
  const PrivateRoutes = lazy(
    () => import(/* webpackChunkName: "PrivateRoutes" */ "./PrivateRoutes"),
  );
  const Unauthorized = lazy(
    () =>
      import(
        /* webpackChunkName: "Unauthorized" */ "../Components/Unauthorized"
      ),
  );
  const Login = lazy(
    () =>
      import(/* webpackChunkName: "Login" */ "../Components/Auth/login/Login"),
  );
  const EmailVerified = lazy(
    () =>
      import(
        /* webpackChunkName: "EmailVerified" */ "../Components/Auth/email-verified/EmailVerified"
      ),
  );
  const Forgot = lazy(
    () =>
      import(
        /* webpackChunkName: "Forgot" */ "../Components/Auth/forgot/Forgot"
      ),
  );
  const ActivateUser = lazy(
    () =>
      import(
        /* webpackChunkName: "ActivateUser" */ "../Components/Auth/Activate/ActivateUser"
      ),
  );
  const LoginSessionClear = lazy(
    () =>
      import(
        /* webpackChunkName: "LoginSessionClear" */ "../Components/Auth/login/LoginSessionClear"
      ),
  );
  const OtherEmail = lazy(
    () =>
      import(
        /* webpackChunkName: "OtherEmail" */ "../Components/Auth/other-email/OtherEmail"
      ),
  );
  const Reset = lazy(
    () =>
      import(/* webpackChunkName: "Reset" */ "../Components/Auth/reset/Reset"),
  );
  const Registration = lazy(
    () =>
      import(
        /* webpackChunkName: "Registration" */ "../Components/Auth/register/Registration"
      ),
  );
  const Faq = lazy(
    () => import(/* webpackChunkName: "Faq" */ "../Components/Common/faq/Faq"),
  );
  const Settings = lazy(
    () =>
      import(
        /* webpackChunkName: "Settings" */ "../Components/Settings/Settings"
      ),
  );
  const Dashboard = lazy(
    () =>
      import(
        /* webpackChunkName: "Dashboard" */ "../Components/Dashboard/Dashboard"
      ),
  );
  const MainReport = lazy(
    () =>
      import(
        /* webpackChunkName: "MainReport" */ "../Components/Bank/report/main/MainReport"
      ),
  );
  const History = lazy(
    () =>
      import(
        /* webpackChunkName: "History" */ "../Components/Bank/History/History"
      ),
  );
  const FinancialHealthScoreDetailedView = lazy(
    () =>
      import(
        /* webpackChunkName: "FinancialHealthScoreDetails" */ "../Components/Bank/report/widget/FinancialHealthScore/FinancialHealthScoreDetails/FinancialHealthScoreDetails"
      ),
  );
  const InsightsAndRecommendation = lazy(
    () =>
      import(
        /* webpackChunkName: "InsightsAndRecommendation" */ "../Components/Bank/report/widget/FinancialHealthScore/FinancialHealthScoreDetails/InsightsAndRecommendation"
      ),
  );
  const EwiChatBot = lazy(
    () =>
      import(
        /* webpackChunkName: "EwiChatBot" */ "../Components/Bank/report/widget/EWiChatBot/EwiChatBot"
      ),
  );
  // const StepThree = lazy(
  //   () =>
  //     import(
  //       /* webpackChunkName: "StepThree" */ "../Components/Bank/wizard/stepThree/StepThree"
  //     ),
  // );
  // const StepTwo = lazy(
  //   () =>
  //     import(
  //       /* webpackChunkName: "StepTwo" */ "../Components/Bank/wizard/stepTwo/StepTwo"
  //     ),
  // );
  // const StepOne = lazy(
  //   () =>
  //     import(
  //       /* webpackChunkName: "StepOne" */ "../Components/Bank/wizard/stepOne/StepOne"
  //     ),
  // );
  const UserManagementRegister = lazy(
    () =>
      import(
        /* webpackChunkName: "UserManagementRegister" */ "../Components/Auth/user-management-register/UserManagementRegister"
      ),
  );
  const Graph = lazy(
    () =>
      import(
        /* webpackChunkName: "Graph" */ "../Components/Bank/report/drilldown/graph/Graph"
      ),
  );
  const List = lazy(
    () =>
      import(
        /* webpackChunkName: "List" */ "../Components/Bank/report/drilldown/list/List"
      ),
  );
  const TopMerchantDetailedView = lazy(
    () =>
      import(
        /* webpackChunkName: "Graph" */ "../Components/Bank/report/widget/DetailedModalMerchant/DetailedModalMerchant"
      ),
  );
  const UserManagementList = lazy(
    () =>
      import(
        /* webpackChunkName: "UserManagementList" */ "../Components/Bank/usermanagement/UserManagementList"
      ),
  );
  const ConsumersListManagementPage = lazy(
    () =>
      import(
        /*webpackChunkName: "ConsumersListManagementPage"*/ "../Components/Bank/CampaignManagement/ConsumersWorkFlow/ConsumersListManagementPage"
      ),
  );
  const SMSCampaignDisplayPage = lazy(
    () =>
      import(
        /*webpackChunkName: "SMSCampaignDisplayPage"*/ "../Components/Bank/CampaignManagement/SMSCampaignWorkFlow/SMSCampaignDisplayPage"
      ),
  );
  const SMSCampaignDetailsPage = lazy(
    () =>
      import(
        /*webpackChunkName: "SMSCampaignDetailsPage"*/ "../Components/Bank/CampaignManagement/SMSCampaignWorkFlow/SMSCampaignDetailsPage"
      ),
  );
  const EditSMSCampaign = lazy(
    () =>
      import(
        /*webpackChunkName: "EditSMSCampaign"*/ "../Components/Bank/CampaignManagement/SMSCampaignWorkFlow/SMSEditCampaign"
      ),
  );
  const ReviewSMSCampaign = lazy(
    () =>
      import(
        /*webpackChunkName: "ReviewSMSCampaign"*/ "../Components/Bank/CampaignManagement/SMSCampaignWorkFlow/SMSReviewCampaign"
      ),
  );
  const CampaignManagementLockedPage = lazy(
    () =>
      import(
        /*webpackChunkName: "CampaignManagementLockedPage"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/CampaignManagementLockedPage"
      ),
  );
  const CampaignManagementPage = lazy(
    () =>
      import(
        /*webpackChunkName: "CampaignManagementPage"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/CampaignManagementPage"
      ),
  );
  const CreateCampaign = lazy(
    () =>
      import(
        /*webpackChunkName: "CreateCampaign"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/CreateCampaign"
      ),
  );
  const CreateSMSCampaign = lazy(
    () =>
      import(
        /*webpackChunkName: "CreateSMSCampaign"*/ "../Components/Bank/CampaignManagement/SMSCampaignWorkFlow/CreateSMSCampaign"
      ),
  );
  const UpdateEmailTemplate = lazy(
    () =>
      import(
        /*webpackChunkName: "UpdateEmailTemplate"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/UpdateEmailTemplate"
      ),
  );
  const EditEmail = lazy(
    () =>
      import(
        /*webpackChunkName: "EditEmail"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/EditEmail"
      ),
  );
  const ReviewEmail = lazy(
    () =>
      import(
        /*webpackChunkName: "ReviewEmail"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/ReviewEmail"
      ),
  );
  const TemplateManagementPage = lazy(
    () =>
      import(
        /*webpackChunkName: "TemplateManagementPage"*/ "../Components/Bank/CampaignManagement/TemplateWorkFlow/TemplateManagementPage"
      ),
  );
  const CreateTemplate = lazy(
    () =>
      import(
        /*webpackChunkName: "CreateTemplate"*/ "../Components/Bank/CampaignManagement/TemplateWorkFlow/CreateTemplate"
      ),
  );
  const UpdateTemplate = lazy(
    () =>
      import(
        /*webpackChunkName: "UpdateTemplate"*/ "../Components/Bank/CampaignManagement/TemplateWorkFlow/UpdateTemplate"
      ),
  );
  const CampaignDetailsPage = lazy(
    () =>
      import(
        /*webpackChunkName: "CampaignDetailsPage"*/ "../Components/Bank/CampaignManagement/CampaignWorkFlow/CampaignDetailsPage"
      ),
  );
  const Invoice = lazy(
    () =>
      import(
        /*webpackChunkName: "Invoice"*/ "../Components/Bank/report/widget/Invoice/Invoice"
      ),
  );
  const StripePricingTable = lazy(
    () =>
      import(
        /*webpackChunkName: "StripePricingTable"*/ "../Components/Common/StripePricingTable/StripePricingTable"
      ),
  );
  const InfiniteBankPerformanceMetrics = lazy(
    () =>
      import(
        /*webpackChunkName: "InfiniteBankPerformanceMetrics"*/ "../Components/Bank/InfiniteBankPerformanceMetrics/InfiniteBankPerformanceMetrics"
      ),
  );
  const EWIMaintenance = lazy(
    () =>
      import(
        /* webpackChunkName: "UserManagementList" */ "../Components/Common/MaintenanceScreens/ewiMaintenance/ewiMaintenance"
      ),
  );

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);
    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);

  const healthAnalysisID = orgReducer?.healthAnalysisID?.uid;

  useEffect(() => {
    if (authReducer.isLogin === true) {
      if (
        healthAnalysisID &&
        !window.location.href.includes("bank") &&
        !window.location.href.includes("pages") &&
        !window.location.href.includes("clearsession") &&
        !window.location.href.includes("login") &&
        !window.location.href.includes("register") &&
        !window.location.href.includes("forgot") &&
        !window.location.href.includes("reset") &&
        !window.location.href.includes("activate") &&
        !window.location.href.includes("email-verified") &&
        !window.location.href.includes("invoice") &&
        !window.location.href.includes("pricingTable") &&
        !window.location.href.includes("nofhsdashboard")
      ) {
        navigate(`/bank/health-analysis/report/${healthAnalysisID}`);
      }
    } else {
      if (window.location.href.includes("pricingTable"))
        navigate(`/user/login`);
    }
    /* eslint-disable-next-line */
  }, [authReducer.isLogin, healthAnalysisID]);

  //This is to check currect path is correct or not
  useEffect(() => {
    const navigationEntries = performance.getEntriesByType("navigation");
    if (
      authReducer.isLogin &&
      navigationEntries.length > 0 &&
      navigationEntries[0].type === "reload"
    ) {
      // navigate(location.pathname);
      navigate(location.pathname, { replace: true });
    } else if (
      authReducer.isLogin &&
      location.pathname &&
      !location?.pathname?.includes("pricingTable")
    ) {
      authReducer?.userData?.role !== "Reseller"
        ? navigate(`/bank/health-analysis/report/${healthAnalysisID}`)
        : navigate(`/user/bankperformancemetrics`);
    }
  }, []);

  if (isLoading || maintenanceData?.is_downtime) return <UnderMaintanance />;

  const EwiRouteHandler = () => {
    return hasSubscription(PRIVILEGES.SHOW_OLD_EWI_CHATBOT) ? (
      <InsightsAndRecommendation />
    ) : (
      <EwiChatBot />
    );
  };

  return (
    <>
      <AuthLayout>
        {isOnline ? (
          <Suspense fallback={<Fallback />}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/user/login" element={<Login />} />
              <Route path="/activate" element={<ActivateUser />} />
              <Route
                path="/user/clearsession"
                element={<LoginSessionClear />}
              />
              <Route path="/user/login/:key" element={<Login />} />
              <Route path="/user/register" element={<Registration />} />
              <Route path="/user/forgot" element={<Forgot />} />
              <Route path="/user/other-user" element={<OtherEmail />} />
              <Route path="/user/reset/" element={<Reset />} />
              <Route path="/user/email-verified" element={<EmailVerified />} />
              <Route path="/login/:key" element={<Login />} />
              <Route path="/forgot" element={<Forgot />} />
              <Route path="/other-user" element={<OtherEmail />} />
              <Route path="/reset/" element={<Reset />} />
              <Route path="/email-verified" element={<EmailVerified />} />
              <Route
                path="/user/user-management-register"
                element={<UserManagementRegister />}
              />
              <Route
                path="/user/pricingTable"
                element={
                  <ProtectedRoute
                    permission={PRIVILEGES.SHOW_SUBSCRIPTION_PAGE}
                    element={<StripePricingTable />}
                  />
                }
              />
              <Route element={<PrivateRoutes />}>
                <Route element={<ResellerRestrictedRoutes />}>
                  <Route
                    path="/user/bankperformancemetrics"
                    element={<InfiniteBankPerformanceMetrics />}
                  />
                  <Route
                    path="/user/nofhsdashboard"
                    element={<NoFHSReseller />}
                  />
                </Route>
                {/* <Route
                  path="/user/setup-inprogress"
                  element={<SetupInprogress />}
                /> */}
                <Route
                  path="/bank/health-analysis/history"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.SHOW_HISTORY_PAGE}
                      element={<History />}
                    />
                  }
                />
                <Route path="/pages/faq" element={<Faq />} />
                <Route path="/pages/faq/:accordianid" element={<Faq />} />
                <Route path="/pages/settings" element={<Settings />} />

                <Route path="/user/invoice" element={<Invoice />} />
                <Route path="/user/graph" element={<Graph />} />
                <Route
                  path="/bank/health-analysis/report/:hid"
                  element={<MainReport />}
                />
                <Route
                  path="/bank/health-analysis/report/:idrssd/financial-health-score"
                  element={<FinancialHealthScoreDetailedView />}
                />
                <Route
                  path="/bank/health-analysis/report/:idrssd/InsightsAndRecommendation"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.SHOW_EWI_STRATEGIES}
                      element={<EwiRouteHandler />}
                    />
                  }
                />
                <Route
                  path="/bank/health-analysis/report/:hid/drilldown/list/:type"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.VIEW_DETAILS_ACCESS}
                      element={<List />}
                    />
                  }
                />
                <Route
                  path="/bank/health-analysis/report/:hid/drilldown/graph/:type"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.DRILLDOWN_ACCESS}
                      element={<Graph />}
                    />
                  }
                />
                <Route
                  path="/bank/health-analysis/report/:hid/top_merchant_detailed_view"
                  element={<TopMerchantDetailedView />}
                />
                {/* <Route element={<CampaignPrivateRoutes />}> */}
                <Route
                  path="/bank/campaign-management/consumers-list"
                  element={
                    <ProtectedRouteWithSubscription
                      permission={PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT}
                      element={<ConsumersListManagementPage />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/consumers-list/:campaignId"
                  element={<ConsumersListManagementPage />}
                />
                <Route
                  path="/bank/campaign-management/consumers-list-details/:consumerListId"
                  element={<ConsumersDetailsPage />}
                />
                <Route
                  path="/bank/campaign-management/consumers-list-details/:campaignId/:consumerListId"
                  element={<ConsumersDetailsPage />}
                />
                <Route
                  path="/bank/campaign-management/SMS_campaigns"
                  element={
                    <ProtectedRouteWithSubscription
                      permission={PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT}
                      element={<SMSCampaignDisplayPage />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/sms-campaigns/:campaignId"
                  element={<SMSCampaignDetailsPage />}
                />
                <Route
                  path="/bank/campaign-management/edit-sms-campaign/:campaignId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.EDIT_SMS_CAMPAIGN}
                      element={<EditSMSCampaign />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/review-sms-campaign/:campaignId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.EDIT_SMS_CAMPAIGN}
                      element={<ReviewSMSCampaign />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/campaign-management-locked"
                  element={
                    <ProtectedRouteWithSubscription
                      permission={[
                        ...PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
                        ...PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
                        ...PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
                        ...PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
                      ]}
                      element={<CampaignManagementLockedPage />}
                      check="either_or_reversed"
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/email-campaigns"
                  element={
                    <ProtectedRouteWithSubscription
                      permission={PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT}
                      element={<CampaignManagementPage />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/email-campaigns/:campaignId"
                  element={<CampaignDetailsPage />}
                />
                <Route
                  path="/bank/campaign-management/create-campaign"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.CREATE_EMAIL_CAMPAIGN}
                      element={<CreateCampaign />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/create-sms-campaign"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.CREATE_SMS_CAMPAIGN}
                      element={<CreateSMSCampaign />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/edit-campaign/:campaignId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.EDIT_EMAIL_CAMPAIGN}
                      element={<EditEmail />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/update-email-template/:campaignId/:templateId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.EDIT_EMAIL_TEMPLATE}
                      element={<UpdateEmailTemplate />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/review-email/:campaignId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.VIEW_EMAIL_CAMPAIGN}
                      element={<ReviewEmail />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/email-templates"
                  element={
                    <ProtectedRouteWithSubscription
                      permission={PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT}
                      element={<TemplateManagementPage />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/create-template"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.CREATE_EMAIL_TEMPLATE}
                      element={<CreateTemplate />}
                    />
                  }
                />
                <Route
                  path="/bank/campaign-management/update-template/:templateId"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.EDIT_EMAIL_TEMPLATE}
                      element={<UpdateTemplate />}
                    />
                  }
                />
                {/* </Route> */}
                <Route
                  path="/bank/user-management/user-management-list"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.SHOW_USER_MANAGEMENT}
                      element={<UserManagementList />}
                    />
                  }
                />
                <Route
                  path="/bank/cohort-management"
                  element={
                    <ProtectedRoute
                      permission={PRIVILEGES.SHOW_COHORT_MANAGEMENT}
                      element={<CohortPage />}
                    />
                  }
                />

                <Route
                  path="/bank/EWI_under_maintenance"
                  element={<EWIMaintenance />}
                />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/" element={<Dashboard />} />
              </Route>
            </Routes>
          </Suspense>
        ) : (
          <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <div className="fs-3">No internet connection.</div>
          </div>
        )}
      </AuthLayout>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        theme="light"
        limit={3}
        style={{
          display: "flex",
          position: "absolute",
        }}
      />
    </>
  );
};
